module.exports = __webpack_public_path__ + "static/media/solution-1-sec1.48efcb0f.png";